import React, { useState, useRef, useEffect } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import axios from "axios";
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Slider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ReactComponent as ChangeImageIcon } from '../../Assets/img/icons/change-image-icon.svg';
import { FILE_TYPE_NAMES } from "../../config/constant";
import { useQuantityContext } from "../QuantityContext";

function FileUpload({ label, contextKey, accept, maxSize, inputId, useContext }) {
  const { cardDetails, updateCardDetails, logo, setLogo } = useContext();
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const { handleInfo } = useQuantityContext();
  const cropperRef = useRef(null);
  const [zoom, setZoom] = useState(100);
  const maxSizeInBytes = maxSize * 1024 * 1024; // Convert MB to bytes

  // Function to handle file selection
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    setSelectedFile(file);
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };


  // Function to handle cropping and saving the image
  const handleCropSave = () => {
    if (!cropperRef.current || !cropperRef.current.getCroppedCanvas) {
      console.error("Cropper not initialized or getCroppedCanvas function not available.");
      return;
    }

    const cropper = cropperRef.current;
    const canvas = cropper.getCroppedCanvas();

    if (canvas) {
      // Create an off-screen canvas to add a white background
      const offscreenCanvas = document.createElement('canvas');
      offscreenCanvas.width = canvas.width;
      offscreenCanvas.height = canvas.height;

      const ctx = offscreenCanvas.getContext('2d');

      // Fill with white background
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

      // Draw the cropped image onto the white background
      ctx.drawImage(canvas, 0, 0);

      offscreenCanvas.toBlob(
        (blob) => {
          const croppedFile = new File([blob], selectedFile.name || 'croppedImage.jpg', {
            type: 'image/jpeg', // Force it to be a JPEG with a white background
          });

          setSelectedImage(URL.createObjectURL(croppedFile));

          const imageObject = {
            name: croppedFile.name,
            type: croppedFile.type,
            data: URL.createObjectURL(croppedFile),
          };

          // console.log("OBJCECT URL", imageObject);
          updateCardDetails({ [contextKey]: imageObject });
          setOpenDialog(false);
          handleFileUpload(imageObject);
        },
        'image/jpeg' // Specify the MIME type for the file
      );
    } else {
      console.error("Canvas not available after cropping.");
    }
  };


  // Function to handle file upload to server
  const handleFileUpload = async (file) => {
    if (!file) {
      console.error('No file to upload.');
      return;
    }
    // console.log("File uploaded successfully!", file);
    try {
      // const formData = new FormData();
      // formData.append('file', file);

      // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // });

      // const sasUrl = response.data.url;


      updateCardDetails({ [contextKey]: file });
    } catch (error) {
      console.error('Error uploading file:', error.message);
      // alert('Error uploading file. Please check the console for details.');

      handleInfo('Error uploading file. Please check the console for details.');
    }
  };

  // Function to handle file changes
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    validateAndUploadFile(file);
    setLogo(file);
    console.log("file is ", file);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    validateAndUploadFile(file);
  };

  const validateAndUploadFile = (file) => {
    if (file && accept.includes(file.type)) {
      if (file.size <= maxSizeInBytes) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64format = reader.result;
          const tempdata = base64format.split(",")[1];
        };
        handleFileUpload(file);
        reader.readAsDataURL(file);


      } else {
        // alert(`File size must be ${maxSize} Mb or less.`);
        handleInfo(`File size must be ${maxSize} Mb or less.`);
      }
    } else {
      // Map MIME types to their short names
      const shortNames = accept.map(type => FILE_TYPE_NAMES[type] || type);

      // alert(`Invalid file type. Only ${shortNames.join(", ")} are allowed.`);
      handleInfo(`Invalid file type. Only ${shortNames.join(", ")} are allowed.`);
    }
  };

  const handleZoomChange = (event, newValue) => {
    updateCardDetails({
      [contextKey]: {
        ...cardDetails?.[contextKey],
        zoom: newValue
      }
    });
  };

  const handleRemoveLogo = () => {
    updateCardDetails({ [contextKey]: '' });
    setLogo(null);
  };

  // Function to handle cropper initialization
  const handleCropperInitialized = (instance) => {
    cropperRef.current = instance;
  };

  const card = cardDetails?.[contextKey];
  // console.log("CARD DETAILS", card?.data);

  return (
    <>
      <div className='add-logo-container text-center'
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}>
        <h5>{label}</h5>
        <div className="file-upload-container" onClick={() => document.getElementById(inputId).click()} style={{ overflow: "hidden", minWidth: "230px", maxWidth: "230px" }}>
          {cardDetails?.[contextKey] !== '' && cardDetails?.[contextKey] !== null ? (
            <>
              <img src={!card?.data ? cardDetails?.[contextKey] : card?.data} alt='Uploaded File' style={{ height: `${zoom}%`, width: `${zoom}%`, transition: 'width 0.2s', objectFit: "contain" }} />
            </>
          ) : (
            <>
              <IconButton color="inherit">
                <CloudUploadRoundedIcon />
              </IconButton>
              <p className='mb-0'>Drag file here or <strong>Upload File</strong></p>
              <div className='tertiary-text'> {maxSize} Mb Max File Size</div>
            </>
          )}
          <input id={inputId} type="file" accept={accept.join(",")} style={{ display: 'none' }} onChange={handleFileSelect} />
        </div>
        {(cardDetails?.[contextKey] && cardDetails?.[contextKey] !== null) && (
          <div className='image-controls' style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: '10px' }}>
            <IconButton color="inherit" onClick={() => document.getElementById(inputId).click()}>
              <ChangeImageIcon />
            </IconButton>
            <IconButton color="inherit" onClick={handleRemoveLogo}>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </div>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Crop Image</DialogTitle>
        <DialogContent>
          <div style={{ width: '100%', height: '400px', position: 'relative' }}>
            <Cropper
              ref={cropperRef}
              src={selectedImage}
              style={{ height: '100%', width: '100%' }}
              initialAspectRatio={1}
              guides={true}
              cropBoxMovable={true}
              cropBoxResizable={true}
              crossOrigin="anonymous"
              dragMode="crop"
              viewMode={1}
              background={false}
              responsive={true}
              autoCrop={false}
              autoCropArea={1}
              minCropBoxHeight={20}
              minCropBoxWidth={20}
              checkOrientation={false}
              onInitialized={handleCropperInitialized}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCropSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default FileUpload;
